<template>
  <div class="editorial" v-if="hide">
    <div class="editorial_nav">
      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">

          首页 <span class="span1">></span>
          <span  @click.stop="tiao2(titlename)" :class="list3.title?'':'bianse'">{{titlename}}</span>
          <span  class="span1">></span> 
          <span class="span2">{{list3.title}}</span>
        </div>
      </div>
      <div class="editorial_left" v-if="tu">
        <div class="editorial_txt1">{{list3.title}}</div>
        <div class="tuxq" v-html="list3.content" :class="titlename=='编委会'?'kuandu':''"></div>
      </div>
      <div class="editorial_left" v-if="!tu" style="position: relative;">
        <div class="editorial_txt1">{{list3.title}}</div>
        <div class="browse_down" @click="down(list3.contentId)" v-if="list3.filePath">
          <span class="iconfont iconxiazai"></span>下载
        </div>
        <div class="editorial_txt2">
          <div style="width: 60%;text-align: center;margin: 0 auto;">
            <span>来源：{{list3.source}}</span>
            <span>作者：{{list3.author}}</span>
            <span>点击：{{list3.hitCount}}</span>
            <span>日期：{{list3.addDate}}</span>
          </div>
        </div>
        <div class="editorial_txt3">
          <div class="tuxq" v-html="list3.content" :class="titlename=='编委会'?'kuandu':'kuandu2'"></div>
        </div>
<!--        <div class="editorial_txt4">
          <div class="editorial_txt4l">
            <img src="/src/assets/ren.jpg" alt="">
          </div>
          <div class="editorial_txt4r">
            <div class="editorial_txt4rtxt1">{{list3.author}}简介</div>
            <div class="editorial_txt4rtxt2">{{list3.abstruct}}</div>
          </div>
        </div> -->
        <div class="shang" v-if="list2.upContentTitle!=null || list2.nextContentTitle!=null">
          <div class="shang_nav" v-if="list2.upContentTitle!=null && list2.nextContentTitle!=null">
            <div class="shangl">上一篇：<span>{{list2.upContentTitle}}</span></div>
            <div class="shangr">下一篇：<span>{{list2.nextContentTitle}}</span></div>
          </div>
          <div class="shang_nav" v-if="list2.upContentTitle!=null || list2.nextContentTitle!=null">
            <div class="shangl" v-if="list2.upContentTitle!=null">上一篇：<span>{{list2.upContentTitle}}</span></div>
            <div class="shangr" v-if="list2.nextContentTitle!=null">下一篇：<span>{{list2.nextContentTitle}}</span></div>
          </div>
        </div>
<!--        <div class="browse_recommend">
          <div class="one">
            <span class="one_xu"></span>
            <span class="one_xian"></span>
          </div>
          <div class="browse_recommendtxt">相关推荐</div>
          <div class="two">
            <span class="two_xian"></span>
            <span class="two_xu"></span>
          </div>
        </div>
        <div class="recommendtxt_list">
          <div class="express_nav2r">
            <div class="express_list2" v-for="(item,index) in list2" :key="index" v-if="index<3" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)">
              <div class="express_dian" :class="item.zt?'add2':''" ></div>
              <div class="express_wen" style="overflow: hidden;width: 95%;">
                <div class="wen1" :class="item.zt?'add1':''" style="float: left;">
                    <span class="span3" :class="item.zt?'add1':''">{{item.txt}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      hide: false,
      tu: false,
      titlename: '',
      currentPage3: 1,//当前页数
      total: 0,//总条数
      list3: [],//详情数据
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list: [
        {
          id: 1,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 2,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 3,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 4,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 5,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 6,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 7,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 8,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 9,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        }
      ],//专家列表
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 3,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 4,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 5,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 6,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 7,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 8,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 9,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
      ],//相关推荐
    }
  },
  watch:{
    '$route'(to,from){
      this.GetContentInfo();
    }
  },
  methods:{
    //下载
    down(contentId){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": 201607080003,
        "contentId": contentId,
        "downType": 3
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
      tiao(){
        this.$router.push({path:'/home'});
      },
      tiao2(name){

        if(name=='首页'){
          this.$router.push({path:'/home'});
        }else if(name=='优先出版'){
          this.$router.push({path:'/expert'});
        }else if(name=='项目合作'){
          this.$router.push({path:'/evolution2'});
        }else if(name=='作者中心'){
          this.$router.push({path:'/oldmeeting'});
        }else if(name=='学术会议' || name=='编辑委员会会议'){
          this.$router.push({path:'/oldmeeting'});
        }else if(name=='阜外说心脏'){
          this.$router.push({path:'/surgery'});
        }else if(name=='新闻公告' || name=='轮播'){
          this.$router.push({path:'/home'});
        }
      },
      //获取内容详情
      GetContentInfo(){
        var channelId;
        var contentId;
        if(this.$route.query.num==1){
          channelId = 2748;
          contentId = this.$route.query.contentId;
          this.titlename = '优先出版';
          sessionStorage.setItem('routerIndex',7);
        }else if(this.$route.query.num==2){
          channelId = 2311;
          contentId = this.$route.query.contentId;
          this.titlename = '项目合作';
          sessionStorage.setItem('routerIndex',9);

        }else if(this.$route.query.num==30){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '首页';
          sessionStorage.setItem('routerIndex',2);
        }else if(this.$route.query.num==4){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '病例分享';
          sessionStorage.setItem('routerIndex',0);
        }else if(this.$route.query.num==5){
          channelId = 2801;
          contentId = this.$route.query.contentId;
          this.titlename = '作者中心';
          sessionStorage.setItem('routerIndex',3);
        }else if(this.$route.query.num==33){
          channelId = 2403;
          contentId = this.$route.query.contentId;
          this.titlename = '阜外说心脏';
          sessionStorage.setItem('routerIndex',3);
        }else if(this.$route.query.num==7){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '最新资讯';
          // sessionStorage.setItem('routerIndex',0);
        }else if(this.$route.query.num==8){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '名刊速览';
          sessionStorage.setItem('routerIndex',0);
        }else if(this.$route.query.num==9){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '轮播';
          sessionStorage.setItem('routerIndex',0);
        }else if(this.$route.query.num==10){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '资讯';
          // sessionStorage.setItem('routerIndex',0);
        }else if(this.$route.query.num==332){
          channelId = this.$route.query.channelId;
          contentId = this.$route.query.contentId;
          this.titlename = '信息公告';
          sessionStorage.setItem('routerIndex',201);
        }else{
          channelId = Number(this.$route.query.channelId);
          contentId = Number(this.$route.query.contentId);
        }
        var that = this;
        var type = 1;
        if(this.$route.query.num==4){
          type = 3;
        }else{
          type = 1;
        }

        that.$httphelper.GetContentInfo({
          "journalId": 201607080003,
          "year":  0,
          "issue": 0,
          "channelId": Number(channelId),
          "contentId": Number(contentId),
          "dataSourceType": type,
          "dataShowType": 1
        }).then(res => {
          if(res.code==200){
            if(that.$route.query.num==4){
              that.list3 = res.data.issueContentInfoResult || '';
            }else{
              that.list3 = res.data.siteContentInfoResult || '';
            }
            if(that.list3.content=='1' && that.$route.query.num!=8){
              that.$router.go(-1);
              window.open(that.list3.filePath);
            }
            that.$loading.hideLoading();
            that.hide = true;
          }else{
            that.hide = true;
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      index(){
        if(this.$route.query.num==3 || this.$route.query.num==7){
          this.tu = true;
        }else{
          this.tu = false;
        }
        this.total = this.list.length;
        this.GetContentInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        console.log(`当前页: ${val}`);
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list2.length;i++){
            if(id==this.list2[i].id){
              this.list2[i].zt = true;
              this.list2.push('1');
              this.list2.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list2.length;i++){
            this.list2[i].zt = false;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      },
  },
  created(){
    this.$loading.showLoading();
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 42px;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .tuxq{
        width: 100%;
        height: auto;
        max-height: 1400px;
        overflow-y: auto;
        /deep/ p{
          margin: 0;
        }
        /deep/ img{
          object-fit: cover;
        }
      }
      .editorial_txt1{
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        margin-bottom: 21px;
      }
      .editorial_txt2{
        width: 100%;
        line-height: 46px;
        background: #F5F5F5;
        margin-bottom: 43px;
        span{
          margin-right: 15px;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 46px;
        }
        span:last-child{
          margin-right: 0;
        }
      }
      .editorial_txt3{
        width: 100%;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #000000;
        line-height: 30px;
        padding-bottom: 50px;
        border-bottom: 1px solid #F6F6F6;
      }
      .editorial_txt4{
        width: 100%;
        overflow: hidden;
        padding-top: 46px;
        .editorial_txt4l{
          width: 18%;
          margin-right: 3%;
          float: left;
          cursor: pointer;
          img{
            width: 100%;
            height: 228px;
          }
          img:hover{
            transform: scale(1.03);
          }
        }
        .editorial_txt4r{
          width: 79%;
          float: left;
          .editorial_txt4rtxt1{
            width: 100%;
            font-size: 20px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
            margin-bottom: 25px;
          }
          .editorial_txt4rtxt2{
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
          }
        }
      }
      .shang{
        width: 100%;
        background-color: #F7F7F7;
        margin-top: 49px;
        .shang_nav{
          width: 80%;
          overflow: hidden;
          margin: 0 auto;
          .shangl,.shangr{
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            color: #000000;
            line-height: 48px;
            cursor: pointer;
            white-space: nowrap;//强制字体不换行
            text-overflow: ellipsis;//超出字体隐藏
            overflow:hidden;
            span:hover{
              color: var(--biao);
              text-decoration: underline;
            }
          }
        }
      }
      .browse_recommend{
        width: 100%;
        margin-top: 49px;
        overflow: hidden;
        .one{
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .one_xu{
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #E4E4E4;
            display: block;
            float: left;
          }
          .one_xian{
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
        .browse_recommendtxt{
          width: 14%;
          float: left;
          text-align: center;
          font-size: 20px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 28px;
        }
        .two{
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .two_xu{
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #E4E4E4;
            display: block;
            float: left;
          }
          .two_xian{
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
      }
      .recommendtxt_list{
        width: 99.8%;
        border: 1px solid #EBEBEB;
        padding: 30px 0 36px 0;
        margin-top: 43px;
        .express_nav2r {
          width: 95%;
          overflow: hidden;
          margin: 0 auto;
          .express_list2 {
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 45px;
            line-height: 20px;
            .express_dian {
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 25px;
              float: left;
              margin-top: 5px;
            }

            .express_wen {
              width: 91%;
              float: left;

              .wen1 {
                width: 100%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;


                .span3 {
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  float: left;
                }
              }

              .wen2 {
                width: 100%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                margin-bottom: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            .zhai {
              width: 90%;
              padding-left: 31px;
              overflow: hidden;
              float: left;

              .wen3 {
                width: 50%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                float: left;
              }

              .zhai_left,
              .zhai_right {
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                float: right;
              }

              .zhai_right {
                margin-left: 30px;
              }

              .zhai_left:hover {
                text-decoration: underline;
                color: var(--biao);
              }

              .zhai_right:hover {
                text-decoration: underline;
                color: var(--biao);
              }
            }
          }
          .express_list2:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  color: var(--xt) !important;
}

.add3 {
  background-color: #FAFAFA !important;
}
.bianse{
  color: var(--xt)!important;
}
.kuandu{
  /deep/ img{
     width: 100%!important;
  }
}
.browse_down{
  cursor: pointer;
  width: 129px;
  height: 44px;
  background: var(--xt);
  text-align: center;
  color: #FFFFFF;
  font-size: 16px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 44px;
  position: absolute;
  right: 45px;
  top: -10px;
  span{
    font-size: 22px;
    margin-right: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/secondary/expert_details.vue